import { Component, OnInit, Input } from '@angular/core';
import { GeneralReportInfo } from '../../../../models/reporting';

@Component({
  selector: 'app-common-report-result',
  templateUrl: './common-report-result.component.html',
  styles: []
})
export class CommonReportResultComponent implements OnInit {
@Input() generalReportInfo: GeneralReportInfo;

  constructor() { }

  ngOnInit() {
  }

}
